import http from "../plugins/axios";

const geoRestrictionsApiCall = async (
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/yandex/geo-restrictions', { signal: abortController?.signal })
    return data
}

const createGeorRestrictionsApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post('/api/company/v3/yandex/geo-restrictions',
        { ...params },
        { signal: abortController?.signal })
    return data
}

const updateGeorRestrictionsApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.patch(`/api/company/v3/yandex/geo-restrictions/${params.id}`,
        { ...params.data },
        { signal: abortController?.signal })
    return data
}

const deleteGeorRestrictionsApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.delete(`/api/company/v3/yandex/geo-restrictions/${params.id}`,
        { signal: abortController?.signal })
    return data
}

const ordersApiCall = async (
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/yandex/orders', { signal: abortController?.signal })
    return data
}

const ordersItemApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.get(`/api/company/v3/yandex/orders/${params.id}`,
        { signal: abortController?.signal })
    return data
}

const createOrdersApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post('/api/company/v3/yandex/orders',
        { ...params },
        { signal: abortController?.signal })
    return data
}

const deleteOrdersApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.delete(`/api/company/v3/yandex/orders/${params.id}`,
        { signal: abortController?.signal })
    return data
}

const promosApiCall = async (
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/yandex/promos?status=active', { signal: abortController?.signal })
    return data
}

const orderPromosApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.get(`/api/company/v3/yandex/orders/${params.id}/promos`,
        { signal: abortController?.signal })
    return data
}


export {
    geoRestrictionsApiCall,
    createGeorRestrictionsApiCall,
    updateGeorRestrictionsApiCall,
    deleteGeorRestrictionsApiCall,
    ordersApiCall,
    ordersItemApiCall,
    createOrdersApiCall,
    deleteOrdersApiCall,
    promosApiCall,
    orderPromosApiCall,
};